import * as firebase from "firebase";
import api from "./api";

const getTokenFirst = (callback, params) =>
  firebase
    .auth()
    .currentUser.getIdToken()
    .then(idToken => {
      localStorage.setItem("token", idToken);
    })
    .then(() => callback(...params))
    .then(obj => obj)
    .catch(err => {
      throw err;
    });

export const newSlack = data =>
  getTokenFirst(api.post, ["/slack/finish_auth", data]);



// WEBPACK FOOTER //
// ./src/util/slack.js